import Pusher from 'pusher-js';
import { config } from 'Constants';

const pusher = new Pusher(config.pusher.id, {
    cluster: 'eu',
    encrypted: true,
});
export const channel = pusher.subscribe('my-channel');
